var _style, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAdmatic(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 422.4 147.1",
    style: {
      enableBackground: "new 0 0 422.4 147.1"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#646463;}\r\n\t.st1{fill:#AC1F23;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "Shape_4_copy_3_36_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.6,4.5C59.8,26.6,62.7,65.5,62.7,65.5v1.1l2.2-1.5c37.4-28.3,78,4.7,78,4.7l4.4,4.7l4.7-4.7L86.6,4.5z "
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_5_copy_3_36_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M63.1,25.6L13,74.2l68.2,66l9.8-9.4C26.8,82.5,63.1,25.6,63.1,25.6z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Shape_8_copy_2_36_"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M67,75.2C65.2,98.1,99,122.8,99,122.8s39.5-39.9,39.5-40.6C103.7,51.7,67,75.2,67,75.2z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M175.9,101.4l13.1-55.5h11.6l12.3,55.5h-11.2l-1.8-9.8h-11.2l-1.5,9.8H175.9z M190.7,83.2h7.3 c-0.7-4-1.5-8-2.2-12.3s-1.1-8.7-1.5-13.4c-0.4,2.2-0.4,4.4-0.7,6.2c-0.4,2.2-0.7,4.4-1.1,6.5L190.7,83.2z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M245.9,101.4h-9.8v-5.4c-1.1,2.2-2.2,3.6-3.6,4.7s-2.9,1.5-4.7,1.5c-3.3,0-6.2-1.8-8-5.1 c-1.8-3.3-2.9-8-2.9-14.5c0-6.2,1.1-10.9,2.9-14.1c1.8-3.3,4.7-5.1,8.3-5.1c1.5,0,2.9,0.4,4.4,1.5c1.5,1.1,2.5,2.2,3.6,4.4V42.2 h9.8V101.4z M236.1,82.1c0-3.6-0.4-6.2-1.1-7.6c-0.7-1.5-1.8-2.5-3.6-2.5c-1.5,0-2.5,0.7-3.3,2.5c-0.7,1.5-1.1,4.4-1.1,8 c0,1.8,0,3.3,0.4,4.7c0,1.5,0.4,2.5,0.7,3.3c0.7,1.8,1.8,2.5,3.3,2.5s2.5-0.7,3.3-2.5C235.7,89,236.1,86.1,236.1,82.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M253.5,101.4l5.4-55.5h14.1l2.9,21c0,1.1,0.4,2.5,0.4,4.4c0.4,1.8,0.4,3.3,0.4,4.7c0,1.5,0.4,2.9,0.4,4.7 c0,1.5,0.4,2.9,0.4,4l1.1-11.6c0.4-2.9,0.7-4.7,0.7-6.2l3.6-21H297l5.1,55.5h-11.2l-1.1-25.8v-2.9c0-2.2,0-3.6,0-5.1 c0-1.1,0-3.3-0.4-6.2c0-2.9,0-4.7,0-5.4l-7.3,45h-8l-6.9-45.3c0,1.1,0,3.3-0.4,6.9c-0.4,3.6-0.4,6.9-0.4,9.4l-0.4,3.6l-1.8,25.8 H253.5z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M336.9,101.4h-9.4v-5.4c-1.1,2.2-2.2,3.6-3.6,4.7s-2.9,1.5-4.7,1.5c-3.6,0-6.2-1.8-8-5.1 c-1.8-3.3-2.9-8-2.9-14.5c0-6.2,1.1-10.9,2.9-14.1c1.8-3.3,4.7-5.1,8.3-5.1c1.5,0,3.3,0.4,4.4,1.5c1.5,1.1,2.5,2.5,4,4.7v-5.8 h9.8v37.7H336.9z M327.5,82.1c0-3.3-0.4-5.8-1.1-7.6c-0.7-1.8-2.2-2.5-3.6-2.5s-2.5,0.7-3.3,2.5c-0.7,1.5-1.1,4.4-1.1,7.6 c0,3.6,0.4,6.2,1.1,8c0.7,1.8,1.8,2.5,3.3,2.5c1.5,0,2.9-0.7,3.6-2.5c0.4-0.7,0.7-1.8,0.7-3.3C327.5,85.8,327.5,84.3,327.5,82.1 z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M347.8,101.4V72h-4v-8h4V53.1h10.2V64h4v8h-4v29.4H347.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M368.1,54.2c0-1.8,0.7-3.3,1.8-4.4s2.5-1.8,4.4-1.8c1.5,0,2.9,0.7,4,1.8s1.8,2.5,1.8,4.4 c0,1.5-0.7,2.9-1.8,4s-2.5,1.8-4.4,1.8s-2.9-0.7-4.4-1.8C368.8,57.1,368.1,55.7,368.1,54.2z M368.8,101.4V64H379v37.4H368.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M408.7,74.9c-0.7-0.7-1.5-1.1-2.2-1.5c-0.7-0.4-1.5-0.4-2.2-0.4c-1.8,0-3.6,0.7-4.7,2.5 c-0.7,0.7-1.1,1.8-1.5,2.9c-0.4,1.1-0.4,2.5-0.4,4c0,2.9,0.7,5.4,1.8,7.3s2.9,2.5,5.1,2.5c0.7,0,1.5,0,2.2-0.4 c0.7-0.4,1.5-0.7,2.2-1.5v9.8c-1.1,0.7-2.2,1.1-3.3,1.5c-1.1,0.4-2.5,0.7-3.6,0.7c-4.4,0-8-1.8-10.5-5.1c-2.5-3.6-4-8.3-4-14.1 s1.5-10.5,4-14.1c2.5-3.6,6.2-5.1,10.5-5.1c1.1,0,2.5,0,3.6,0.4c0.7,0,1.1,0.4,1.8,0.4c0.4,0,1.1,0.4,1.8,0.7v9.4H408.7z"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdmatic);
export default __webpack_public_path__ + "static/media/admatic.c1aa49ec127a4d7a7f77ed506c3e8ea1.svg";
export { ForwardRef as ReactComponent };